"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = void 0;
var type_1 = require("../types/type");
var utils_1 = require("../types/utils");
var util_1 = require("./util");
var dateValues_1 = require("./dateValues");
var moment_1 = __importDefault(require("moment"));
exports.Value = {
    /**
     * Create a value object from the given number.
     */
    number: function (value) {
        return { type: type_1.NumberType, value: value };
    },
    /**
     * Create a value object from the given string.
     */
    string: function (value) {
        return { type: type_1.StringType, value: value };
    },
    /**
     * Create a value object from the given array of element values.
     *
     * The {@link ArrayType.elements} type will be inferred based on the types of the values.
     */
    array: function (elements) {
        var elementType;
        if (elements.length === 0) {
            elementType = type_1.VoidType;
        }
        else if (elements.length === 1) {
            elementType = elements[0].type;
        }
        else {
            var union = utils_1.collapseUnion({ type: 'union', options: elements.map(function (el) { return el.type; }) });
            if (union.options.length === 1) {
                elementType = union.options[0];
            }
            else {
                elementType = union;
            }
        }
        return { type: { type: type_1.AnyArrayType, elements: elementType }, elements: elements };
    },
    /**
     * Create a value object from the given boolean.
     */
    boolean: function (value) {
        return { type: type_1.BooleanType, value: value };
    },
    /**
     * Attempt to convert the given value from a plain JS value in a {@link Value} object.
     *
     * Strings, numbers, and booleans will be converted to their respective value objects.
     *
     * Arrays will be converted to array values by calling {@code fromJSValue} on their elements.
     *
     * JavaScript {@link Date} objects will be converted to {@link DateTimeValue}s.
     *
     * The result of converting {@code null}/{@code undefined} is undefined and should not be relied upon.
     *
     * @throws {@link Error} if passed a value that could not be converted.
     */
    fromJSValue: function (value) {
        if (typeof value === "string") {
            return exports.Value.string(value);
        }
        else if (typeof value === "number") {
            return exports.Value.number(value);
        }
        else if (typeof value === "boolean") {
            return exports.Value.boolean(value);
        }
        else if (!value) {
            // todo: do we need a null/void value?
            return exports.Value.string("");
        }
        else if (Array.isArray(value)) {
            return exports.Value.array(value.map(this.fromJSValue));
        }
        else if (value instanceof Date) {
            return new dateValues_1.DateTimeValue(moment_1.default(value));
        }
        else {
            throw new Error("Unable to convert JS value to formula value");
        }
    },
    /**
     * Converts the formula value object into a plain JavaScript value.
     *
     * String, number, and boolean values will have their underlying values returned.
     *
     * Array values will be converted by calling {@code toJSValue} on each of the array's element values.
     *
     * Date, time, and datetime values will be converted to JS {@link Date} objects.
     */
    toJSValue: function (value) {
        if (util_1.isStringValue(value)) {
            return value.value;
        }
        else if (value instanceof dateValues_1.DateValue || value instanceof dateValues_1.TimeValue || value instanceof dateValues_1.DateTimeValue) {
            return value.moment.toDate();
        }
        else if (util_1.isNumberValue(value)) {
            return value.value;
        }
        else if (util_1.isBooleanValue(value)) {
            return value.value;
        }
        else if (util_1.isArrayValue(value)) {
            return value.elements.map(this.toJSValue);
        }
    },
};
//# sourceMappingURL=value.js.map